import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef,
  HostListener,
} from '@angular/core';

interface DateRangeOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-date-range-filter',
  templateUrl: './date-range-filter.component.html',
  styleUrls: ['./date-range-filter.component.scss'],
})
export class DateRangeFilterComponent implements OnInit, OnChanges {
  @Input() value: string = '30d';
  @Output() valueChange = new EventEmitter<string>();

  // Equivalent of `className` prop; bind via [extraClass]
  @Input() extraClass: string = '';

  isOpen = false;
  selectedValue = '30d';

  readonly dateRangeOptions: DateRangeOption[] = [
    { label: 'Last 30 days', value: '30d' },
    { label: 'Last 60 days', value: '60d' },
    { label: 'Last 90 days', value: '90d' },
    { label: 'All time', value: 'all' },
  ];

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.selectedValue = this.value || '30d';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && !changes.value.firstChange) {
      this.selectedValue = changes.value.currentValue || '30d';
    }
  }

  get selectedOption(): DateRangeOption | undefined {
    return this.dateRangeOptions.find(
      (option) => option.value === this.selectedValue
    );
  }

  toggleOpen(): void {
    this.isOpen = !this.isOpen;
  }

  select(option: DateRangeOption): void {
    this.selectedValue = option.value;
    this.valueChange.emit(option.value);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.host.nativeElement.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }
}
